import { render, staticRenderFns } from "./ActiveFilterCount.vue?vue&type=template&id=2875e93c&scoped=true&"
import script from "./ActiveFilterCount.vue?vue&type=script&lang=js&"
export * from "./ActiveFilterCount.vue?vue&type=script&lang=js&"
import style0 from "./ActiveFilterCount.vue?vue&type=style&index=0&id=2875e93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2875e93c",
  null
  
)

export default component.exports